import Component from "../classes/Component"
import each from 'lodash/each'
import { gsap } from "gsap"
import { app, menu } from '../utils/store'

export default class Menu extends Component {
    constructor({ element }) {
        super({
            id: element.getAttribute('data-navigation-menu') ? element.getAttribute('data-navigation-menu') : element.id,
            element: `[data-navigation-menu="${element.getAttribute('data-navigation-menu')}"]`,
            elements: {
                toggler: document.querySelector(`[data-menu-target="${element.id}"]`),
                closer: 'button[data-closer]'
            }
        })

        if (this.elements.toggler) { this.elements.toggler.onclick = (event) => this.onClick(event) }
        if (this.elements.closer) { this.elements.closer.onclick = (event) => this.onClick(event) }
    }

    create() {
        super.create()

        let list = this.element.querySelector("ul.default")
        let featured = this.element.querySelector("a.featured")


        if (list && featured) {
            this.items = new MenuItems({
                element: list,
                target: featured
            })
        }
    }
    addEventListeners = () => {
        // window.addEventListener('resize', () => {
        //     app.root.classList.remove('menu--open')
        //     app.html.classList.remove('scroll--off')
        //     menu.isOpen = false
        //     menu.current = null
        // })
    }

    onClick = (event) => {
        event.preventDefault()
        this.element.classList.toggle('active')

        if (app.html.classList.contains('loading')) {
            return;
        }

        if (!menu.isOpen) {
            app.root.classList.add('menu--open')
            app.html.classList.add('scroll--off')
            menu.id = this.element.getAttribute('data-navigation-menu')
            menu.current = this.element
            menu.isOpen = true
        } else if (menu.isOpen && event.target.hasAttribute('data-menu-id') && (menu.id != event.target.getAttribute('data-menu-id'))) {
            let active = document.getElementById(`menu-${menu.id}`)
            active.classList.remove('active')

            menu.id = this.element.getAttribute('data-navigation-menu')
            menu.current = this.element
        } else {
            app.root.classList.remove('menu--open')
            menu.id = null
            menu.current = null
            menu.isOpen = false

            if (!document.querySelector('.navigation--open')) {
                app.html.classList.remove('scroll--off');
            }
        }
    }

    onScroll = () => {

    }

    destroy = () => { /** Code your own */ }
}

export class MenuItems {
    constructor({ element, target }) {
        this.element = element
        this.target = target
        this.currentTween = null
        this.currentSrc = null

        this.create()
    }

    create = () => {
        this.links = this.element.querySelectorAll("a[data-gallery]")
        this.target = {
            figure: this.target.querySelector("img"),
            background: this.target
        }

        if (this.links) {
            const gallery = new Array()

            each(this.links, (entry, index) => {
                gallery.push(JSON.parse(entry.getAttribute("data-gallery")))

                entry.onmouseenter = () => {
                    const newBackgroundImage = `url(${gallery[index][0]})`
                    const newSrc = gallery[index][1]

                    if (newSrc === this.currentSrc) { return }

                    if (this.currentTween) {
                        this.currentTween.kill()
                    }

                    this.currentSrc = newSrc

                    this.currentTween = gsap.to([this.target.background, this.target.figure], {
                        opacity: 0,
                        duration: 0.3,
                        onComplete: () => {
                            this.target.background.style.backgroundImage = newBackgroundImage
                            this.target.figure.src = newSrc
                            gsap.to([this.target.background, this.target.figure], { opacity: 1, duration: 0.3 })
                        }
                    })
                }
            })
        }
    }
}